import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Event from '../Event.vue';
import Avatar from "@/components/Avatar.vue";
import VueSimpleContextMenu from 'vue-simple-context-menu';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import AnimatedClockIcon from "@/components/Utils/AnimatedClockIcon.vue";
let CalendarWeek = class CalendarWeek extends Vue {
    heading;
    start;
    rows;
    isNow;
    areDataLoading;
    lineHeight;
    createModal;
    events;
    clickEvent;
    step;
    isToday;
    dateTime;
    change;
    createBlockAppointmentTimeModal;
    list;
    confirmMove;
    staff;
    lineWidth = null;
    selected = {
        day: null,
        start: null,
        end: null,
        isSelecting: false,
        startingPoint: null,
        userId: null,
    };
    get contextMenuOptions() {
        return [
            {
                name: this.$t('New appointment'),
                value: 'appointment',
            },
            {
                name: this.$t('Block The Time'),
                value: 'block'
            }
        ];
    }
    $refs;
    updated() {
        this.$nextTick(() => {
            this.lineWidthCalendarCell();
        });
    }
    lineWidthCalendarCell() {
        if (!this.$refs.calendarRow)
            return;
        if (!this.$refs.calendarRow[0])
            return;
        this.lineWidth = this.$refs.calendarRow[0].clientWidth;
    }
    get_staff_for_today(row) {
        let staff = this.staff;
        let workingStaff = [];
        staff.map((member) => {
            let memberSchedule = member.schedule.map((el) => el.dayOfWeek);
            //@ts-ignore
            let workingDay = this.$dayOfWeek(this.$moment(row).isoWeekday());
            if (memberSchedule.includes(workingDay))
                workingStaff.push(member);
        });
        return workingStaff;
    }
    handleMouseOver(date, row) {
        if (!this.selected.isSelecting)
            return;
        const startingPoint = this.dateTime(date, this.selected.startingPoint);
        const currentDate = this.dateTime(date, row);
        if (currentDate.isBefore(startingPoint)) {
            this.selected.start = row;
            this.selected.end = this.selected.startingPoint;
        }
        else if (currentDate.isAfter(startingPoint)) {
            this.selected.end = row;
        }
        else {
            this.selected.start = this.selected.startingPoint;
            this.selected.end = row;
        }
    }
    handleMouseDown(date, row, userId) {
        this.emptySelected();
        document.documentElement.style.userSelect = "none";
        this.selected.isSelecting = true;
        this.selected.day = date;
        this.selected.start = row;
        this.selected.end = row;
        this.selected.startingPoint = row;
        this.selected.userId = userId;
    }
    handleMouseUp(date, row, $event) {
        document.documentElement.style.userSelect = "text";
        this.selected.isSelecting = false;
        $event.preventDefault();
        $event.stopPropagation();
        setTimeout(() => {
            //@ts-ignore
            if (this.$moment(this.selected.start).diff(this.$moment(this.selected.end), 'minute')) {
                this.fixContextMenuPosition($event, 100, 100);
                this.$refs.calendarStaffContextMenu.showMenu($event, null);
            }
        }, 100);
    }
    isColSelected(date, row, userId) {
        if (this.selected.day === date && this.selected.userId === userId) {
            const currentDay = this.dateTime(date, row);
            let start = this.dateTime(date, this.selected.start);
            let end = this.dateTime(date, this.selected.end);
            if (start.isSame(end))
                return false;
            //@ts-ignore
            if (this.$moment(currentDay).isBetween(start, end, 'minutes', '[]')) {
                return true;
            }
        }
        else {
            return false;
        }
    }
    handleClick($event, item) {
        this.fixContextMenuPosition($event, 120, 80);
        this.$refs.calendarStaffContextMenu.showMenu($event, item);
    }
    optionClicked(data) {
        if (data.item !== null) {
            data.option.value === 'appointment' ?
                this.createModal(this.dateTime(data.item[0], data.item[1]), { userId: data.item[2] }) :
                this.createBlockAppointmentTimeModal(this.dateTime(data.item[0], data.item[1]), { userId: data.item[2] });
        }
        else {
            //@ts-ignore
            const endAt = this.$moment(this.selected.end).add(this.step, 'minute');
            data.option.value === 'appointment' ?
                this.createModal(this.dateTime(this.selected.day, this.selected.start), { userId: this.selected.userId }, this.dateTime(this.selected.day, endAt)) :
                this.createBlockAppointmentTimeModal(this.dateTime(this.selected.day, this.selected.start), { userId: this.selected.userId }, this.dateTime(this.selected.day, endAt));
            this.emptySelected();
        }
    }
    fixContextMenuPosition($event, pageX, pageY) {
        Object.defineProperty($event, 'pageX', {
            value: $event.pageX - pageX,
            writable: true
        });
        Object.defineProperty($event, 'pageY', {
            value: $event.pageY - pageY,
            writable: true
        });
    }
    emptySelected() {
        this.selected = { day: null, start: null, end: null, isSelecting: false, startingPoint: null, userId: null };
    }
};
__decorate([
    Prop({ type: Array })
], CalendarWeek.prototype, "heading", void 0);
__decorate([
    Prop({ type: String })
], CalendarWeek.prototype, "start", void 0);
__decorate([
    Prop({ type: Array })
], CalendarWeek.prototype, "rows", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "isNow", void 0);
__decorate([
    Prop({ type: Boolean })
], CalendarWeek.prototype, "areDataLoading", void 0);
__decorate([
    Prop({ type: Number })
], CalendarWeek.prototype, "lineHeight", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "createModal", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "events", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "clickEvent", void 0);
__decorate([
    Prop({ type: Number })
], CalendarWeek.prototype, "step", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "isToday", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "dateTime", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "change", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "createBlockAppointmentTimeModal", void 0);
__decorate([
    Prop({ type: Object })
], CalendarWeek.prototype, "list", void 0);
__decorate([
    Prop({ type: Function })
], CalendarWeek.prototype, "confirmMove", void 0);
__decorate([
    Prop({ type: Array })
], CalendarWeek.prototype, "staff", void 0);
CalendarWeek = __decorate([
    Component({
        components: {
            Event,
            Avatar,
            VueSimpleContextMenu,
            AnimatedClockIcon
        }
    })
], CalendarWeek);
export default CalendarWeek;
